import { paths } from '@common/types';
import { axiosInstance } from '@config/axios/axios.config';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const loginEmailMagicLinkRequest = async (
  props: paths['/auth/request/email-login']['post']['requestBody']['content']['application/json'],
) => {
  const response = axiosInstance.post<
    paths['/auth/request/email-login']['post']['requestBody']['content']['application/json'],
    paths['/auth/request/email-login']['post']['responses']['200']['content']['application/json']
  >(`/auth/request/email-login`, {
    ...props,
  });
  const data = await response;

  return data;
};

export const useLoginMagicLinkMutation = () => {
  const mutation = useMutation({
    mutationKey: ['loginEmailPassword'],
    mutationFn: (
      props: paths['/auth/request/email-login']['post']['requestBody']['content']['application/json'],
    ) => loginEmailMagicLinkRequest(props),
  });

  return mutation;
};

const registerPasswordRequest = async (
  props: paths['/auth/register/password']['post']['requestBody']['content']['application/json'],
) => {
  const response = axiosInstance.post<
    paths['/auth/register/password']['post']['requestBody']['content']['application/json'],
    paths['/auth/register/password']['post']['responses']['201']['content']['application/json']
  >(`/auth/register/password`, {
    ...props,
  });
  const data = await response;

  return data;
};

export const useRegisterPasswordMutation = () => {
  const mutation = useMutation({
    mutationKey: ['registerUser'],
    mutationFn: (
      props: paths['/auth/register/password']['post']['requestBody']['content']['application/json'],
    ) => registerPasswordRequest(props),
  });

  return mutation;
};

const resetPasswordRequest = async (
  props: paths['/auth/password-reset']['post']['requestBody']['content']['application/json'],
) => {
  const response = axiosInstance.post<
    paths['/auth/password-reset']['post']['requestBody']['content']['application/json'],
    paths['/auth/password-reset']['post']['responses']['200']['content']['application/json']
  >(`/auth/password-reset`, {
    ...props,
  });
  const data = await response;

  return data;
};

export const useResetPasswordMutation = () => {
  const mutation = useMutation({
    mutationKey: ['resetPassword'],
    mutationFn: (
      props: paths['/auth/password-reset']['post']['requestBody']['content']['application/json'],
    ) => resetPasswordRequest(props),
  });

  return mutation;
};

const requestResetPasswordRequest = async (
  props: paths['/auth/request/password-reset']['post']['requestBody']['content']['application/json'],
) => {
  const response = axiosInstance.post<
    paths['/auth/request/password-reset']['post']['requestBody']['content']['application/json'],
    paths['/auth/request/password-reset']['post']['responses']['200']['content']['application/json']
  >(`/auth/request/password-reset`, {
    ...props,
  });
  const data = await response;

  return data;
};

export const useRequestResetPasswordMutation = () => {
  const mutation = useMutation({
    mutationKey: ['requestResetPassword'],
    mutationFn: (
      props: paths['/auth/request/password-reset']['post']['requestBody']['content']['application/json'],
    ) => requestResetPasswordRequest(props),
  });

  return mutation;
};

const logoutRequest = async () => {
  await axiosInstance.post<
    paths['/auth/logout']['post']['responses']['200']['content'],
    undefined,
    paths['/auth/logout']['post']['requestBody']['content']['application/json']
  >(`/auth/logout`, { token: localStorage.getItem('token')! });
};

export const useLogoutMutation = () => {
  const client = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['logout'],
    mutationFn: () => logoutRequest(),
    onSuccess: () => client.removeQueries(),
  });

  return mutation;
};
